import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import DesktopMacIcon from '@material-ui/icons/DesktopMac';
import MapIcon from '@material-ui/icons/Map';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DnsIcon from '@material-ui/icons/Dns';
import BrandingWatermarkIcon from '@material-ui/icons/BrandingWatermark';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
			},
		],
	},
	{
		title: 'Modules',
		pages: [
			// {
			// 	title: 'Tracker',
			// 	href: '/tracker',
			// 	icon: CalendarTodayIcon,
			// 	// roles: ['Administrator', ...]
			// 	children: [
			// {
			// 	title: 'Import',
			// 	href: '/tracker/import',
			// },
			{
				title: 'Failures',
				href: '/modules/failures',
				icon: AssignmentIcon
			},
			{
				title: 'Map',
				href: '/modules/map',
				icon: MapIcon
			},
			{
				title: 'Algorithms',
				href: '/modules/algorithms',
				icon: DnsIcon
			},
			{
				title: 'PDF Repository',
				href: '/modules/repositoryPdf',
				// roles: ['Administrator'],
				icon: BrandingWatermarkIcon
			},
			{
				title: 'Excel Repository',
				href: '/modules/repositoryExcel',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: FileCopyIcon
			},
			{
				title: 'Site Optimizations',
				href: '/modules/optSiteTracker',
				icon: SettingsInputAntennaIcon
			},
			{
				title: 'Overall Optimizations',
				href: '/modules/optOverallTracker',
				// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				icon: DeveloperBoardIcon
			}
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					},
					{
						title: 'Statistics',
						href: '/management/statistics',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	}
];
